module.exports = __webpack_public_path__ + "img/razorpay.df4b1f60.svg";